import { useEffect, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";
export function useDimensionObserver(ref) {
    var _a = useState(), width = _a[0], setWidth = _a[1];
    var _b = useState(), height = _b[0], setHeight = _b[1];
    useEffect(function () {
        if (!ref || !ref.current) {
            return;
        }
        setWidth(ref.current.clientWidth);
        setHeight(ref.current.clientHeight);
        //@ts-ignore
        var resizeObserver = new ResizeObserver(function (entries) {
            var entry = entries[0];
            setWidth(entry.contentRect.width);
            setHeight(entry.contentRect.height);
        });
        resizeObserver.observe(ref.current);
        return function cleanup() {
            if (resizeObserver && ref && ref.current) {
                resizeObserver.unobserve(ref.current);
            }
        };
    }, [ref]);
    return { width: width, height: height };
}
//# sourceMappingURL=useDimensionObserver.js.map